import { SET_SEND_COST } from "../actions/sendCostAction";

export default function sendCostReducer(state = 0, action) {
    switch (action.type) {
        case SET_SEND_COST:
            return action.payload
        default:
           return state;
    }
}


